/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const removeCustomerTeamAssignmentBodyExpectedCustomerVersionExclusiveMin = 0;
export const removeCustomerTeamAssignmentBodyExpectedCustomerVersionMax = 9007199254740991;

export const RemoveCustomerTeamAssignmentBody = zod.object({
  expectedCustomerVersion: zod
    .int()
    .gt(removeCustomerTeamAssignmentBodyExpectedCustomerVersionExclusiveMin)
    .max(removeCustomerTeamAssignmentBodyExpectedCustomerVersionMax),
});

export type RemoveCustomerTeamAssignmentBody = zod.input<typeof RemoveCustomerTeamAssignmentBody>;
export type RemoveCustomerTeamAssignmentBodyOutput = zod.output<
  typeof RemoveCustomerTeamAssignmentBody
>;
